export { RepositoriesList } from './RepositoriesList';


// WEBPACK FOOTER //
// ./src/components/RepositoriesList/index.js